export const types = {
  Admin: 0,
  Maintainer: 1,
  Teacher: 2,
  Coordinator: 3,
  Student: 4,
  Guardian: 5
}

export const displayNames = {
  [types.Student]: 'Aluno',
  [types.Teacher]: 'Professor',
  [types.Maintainer]: 'Mantenedor',
  [types.Guardian]: 'Responsável',
  [types.Coordinator]: 'Coordenador'
}

export function getTextForDisplay (type) {
  const name = displayNames[type]

  if (name === undefined) {
    return ''
  }

  return name
}

export default {
  types,
  displayNames,
  getTextForDisplay
}
